var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.59863 14.9775V37.5255M6.59863 37.5255C7.38433 37.4775 8.35296 37.4775 9.59863 37.4775H38.5986C39.8444 37.4775 40.8129 37.4775 41.5986 37.5255M6.59863 37.5255C5.61811 37.5853 4.92246 37.72 4.32868 38.0225C3.38786 38.5018 2.62296 39.2668 2.14361 40.2075C1.59863 41.277 1.59863 42.6773 1.59863 45.4775V47.4775H46.5986V45.4775C46.5986 42.6773 46.5986 41.277 46.0536 40.2075C45.5744 39.2668 44.8094 38.5018 43.8686 38.0225C43.2749 37.72 42.5791 37.5853 41.5986 37.5255M16.5986 14.9775V37.4775M31.5986 14.9775V37.4775M41.5986 14.9775V37.5255M1.59863 8.72754V14.9775H46.5986V8.72754L24.0986 2.47754L1.59863 8.72754Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingIcon);
export default __webpack_public_path__ + "static/media/building-icon.b68096e923216af94dab9f69d0d24816.svg";
export { ForwardRef as ReactComponent };